export const SET_RESEARCH = "ADS:SET_RESEARCH";
export const RESET_RESEARCH = "ADS:RESET_RESEARCH";
export const SET_ADVERTISE = "ADS:SET_ADVERTISE";
export const SET_ADS = "ADS:SET_ADS";
export const SET_PING = "ADS:SET_PING";
export const CLEAR_ADVERTISE = "ADS:CLEAR_ADVERTISE";
